import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { AccountantShell } from '@/app/shell/AccountantShell';
import { AccountantReviewPage } from '@/features/business/accountant/AccountantReviewPage';
import { AccountantOpenItemsPage } from '@/features/business/open-items/AccountantOpenItemsPage';
import { ScheduleCPage } from '@/features/business/schedule-c/ScheduleCPage';
import { AccountantExportPage } from '@/features/business/export/AccountantExportPage';

const ROUTE_HEADINGS: Record<string, string> = {
  review: 'Business review',
  'open-items': 'Open items',
  'schedule-c': 'Schedule C',
  exports: 'Export package',
};

export function AccountantRoute() {
  const location = useLocation();
  const { grantId, taxYear: taxYearParam } = useParams<{ grantId: string; taxYear: string }>();
  const pathParts = location.pathname.split('/');
  const suffix = pathParts[pathParts.length - 1] ?? '';
  const heading = useMemo(() => {
    return ROUTE_HEADINGS[suffix] ?? 'Accountant workspace';
  }, [suffix]);
  const taxYear = Number(taxYearParam);

  let page: React.ReactNode = (
    <section aria-label={`${heading} status`} className="rounded-lg border border-dashed p-6" data-testid="accountant-route-unavailable">
      <p className="text-sm text-muted-foreground">Accountant workspace is unavailable for this route.</p>
    </section>
  );
  if (grantId && taxYearParam && Number.isInteger(taxYear) && taxYear > 0) {
    const pageProps = { grantId, taxYear };
    page = suffix === 'review'
      ? <AccountantReviewPage {...pageProps} />
      : suffix === 'open-items'
        ? <AccountantOpenItemsPage {...pageProps} />
        : suffix === 'schedule-c'
          ? <ScheduleCPage {...pageProps} />
          : suffix === 'exports'
            ? <AccountantExportPage {...pageProps} />
            : page;
  }

  return (
    <AccountantShell heading={heading}>
      {page}
    </AccountantShell>
  );
}

export default AccountantRoute;
